import { render, staticRenderFns } from "./mdItemInfo.vue?vue&type=template&id=02729518&scoped=true&"
import script from "./mdItemInfo.vue?vue&type=script&lang=js&"
export * from "./mdItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./mdItemInfo.vue?vue&type=style&index=0&id=02729518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02729518",
  null
  
)

export default component.exports